<template>

	<div class="header" v-loading.fullscreen.lock="logoutLoading">

		<div class="header-con clearfix">
			<div class="logo fl">
				<span><img
					:src="logoImg" style="width:268px;"></span>
			</div>
			<div class="link fl">
				<router-link :to="{name:'index'}" v-if="!isLogin" class="link-item"
							 :class="{active:$route.name === 'index'}">
					专区首页 <span class="text-line"></span>
				</router-link>
				<a :href="walfare" class="link-item" v-if="showAvatar" target="_blank">作家福利 <span
					class="text-line"></span></a>
				<a :href="pcSiteHost" class="link-item" v-if="showAvatar" target="_blank">返回{{siteName}} <span
					class="text-line"></span></a>

				<router-link :to="{name:'notices'}" :class="{active:$route.name === 'notices'}"
							 v-if="!isLogin && authorInfo" class="link-item">
					<el-badge
						v-if="authorInfo.authorMark && authorInfo.authorMark.user_unread_msg_num_data>0"
						:value="authorInfo.authorMark && authorInfo.authorMark.user_unread_msg_num_data"
						:max="10">
						消息<span class="text-line"></span>
					</el-badge>
					<a v-else>消息<span class="text-line"></span></a>

				</router-link>
			</div>


			<el-dropdown class="login fr" v-if="showAvatar" placement="bottom-start">
				<div class="fr">
					<span class="avatar-text">{{authorInfo.penName}}</span>
					<a href="javascript:void(0)" class="avatar">
						<!--todo 增加默认图片 指令-->
						<img :src="authorInfo.iconUrl">
					</a>
				</div>

				<el-dropdown-menu slot="dropdown" style="text-align: center;">
					<el-dropdown-item v-if="!registering" style="padding: 3px 25px;font-size: 14px">
						<router-link :to="{name:'basic'}">基本信息</router-link>
					</el-dropdown-item>
					<el-dropdown-item v-if="!registering&&authorInfo.authorMark.can_modify_author_info"
									  style="padding: 3px 25px;font-size: 14px">
						<router-link :to="{name:'modifyInfo',params:{userId:authorInfo.userId}}" target="_blank">
							签约信息
						</router-link>
					</el-dropdown-item>
					<el-dropdown-item v-if="!registering&&authorInfo.isSignAuthor"
									  style="padding: 3px 25px;font-size: 14px">
						<router-link :to="{name:'accountBind'}" target="_blank">
							账号绑定
						</router-link>
					</el-dropdown-item>
					<el-dropdown-item style="padding: 3px 25px;font-size: 14px">
						<div @click="doLogout">退出</div>
					</el-dropdown-item>
				</el-dropdown-menu>

			</el-dropdown>


		</div>

	</div>

</template>

<script>
	import {doLogout} from '@/api/user'
	import zuitanglogo from '@/assets/zuitanglogo.png'
	import zuitanglogo2x from '@/assets/zuitanglogo-2x.png'
	import motielogo from '@/assets/motielogo.png'
	import motielogo2x from '@/assets/motielogo-2x.png'

	export default {
		data() {
			return {
				devicePixelRatio: window.devicePixelRatio,
				logoutLoading: false
			}
		},
		computed: {
			authorInfo() {
				return this.$store.getters['user/getUserInfo'] || {}
			},
			isLogin() {
				return this.$route.name === 'login' || this.$route.name === 'register'
			},
			showAvatar() {
				return this.$route.name !== 'login'
			},
			registering() {
				return this.$route.name === 'register'
			},
			siteName() {
				return this.$store.state.app.headerSiteName
			},
			site() {
				return this.$store.state.app.site
			},
			pcSiteHost() {
				return this.$store.state.app.pcSiteHost
			},
			logoImg() {
				//window.devicePixelRatio
				if (this.$store.state.app.site === 'zuitang') {
					if (devicePixelRatio > 1) {
						return zuitanglogo2x
					} else {
						return zuitanglogo
					}
				} else {
					if (devicePixelRatio > 1) {
						return motielogo2x
					} else {
						return motielogo
					}

				}
			},
			walfare() {
				let path = ''
				if (this.site === 'jw') {
					path = 'jinwen'
				} else if (this.site === 'mm') {
					path = 'mm'
				} else if (this.site === 'zuitang') {
					path = 'zuitang'
				} else if (this.site === 'yynovel') {
					path = 'yiyun'
				} else {
					path = 'motie'
				}

				return this.pcSiteHost+'/about/reward/' + path
			}

		},
		methods: {
			async doLogout() {
				this.logoutLoading = true
				let res = await doLogout()
				this.logoutLoading = false
				if (res.data.items) {
					this.$store.commit('user/logoutMutaion')
					this.$router.push({name: 'login'})
				} else {
					this.$message({
						message: res.data.msg,
						type: 'warning',
					})
				}
			}
		},
	}
</script>

<style scoped lang="scss">
	.header {
		width: 100vw;
		position: fixed;
		left: 0;
		top: 0;
		height: 60px;
		line-height: 60px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		background-color: #fff;
		z-index: 1000;
	}

	.header-con {
		background: #fff;
		position: relative;
		max-width: 1200px;
		margin: 0 auto;
		z-index: 2;
		height: 60px;
		min-width: 740px;
	}

	.logo {
		position: absolute;
		left: 0;
		a {
			display: block;
			height: 40px;
		}
		height: 50px;
		top: 7px;
	}

	.link {
		position: absolute;
		left: 41%;

		.link-item {
			font-size: 16px;
			float: left;
			margin-right: 56px;
			color: #333;
			position: relative;
			.text-line {
				position: absolute;
				display: none;
				width: 30px;
				height: 3px;
				background-color: #21ade5;
				bottom: 3px;
				left: 50%;
				margin-left: -15px;
			}
			&.active {
				.text-line {
					display: block;
				}
			}
		}

	}


	@media (max-width: 1040px) {
		.link .link-item {
			margin-right: 30px;
		}
	}
	@media (max-width: 900px) {
		.link .link-item {
			margin-right: 20px;
		}
	}
	@media (max-width: 860px) {
		.link .link-item {
			margin-right: 10px;
		}
	}

	.login {
		position: absolute;
		right: 0;
		top: 0;
		background-color: #fff;
		/*width: 200px;*/

		.avatar {
			height: 40px;
			width: 40px;
			border-radius: 50%;
			float: right;
			margin-top: 10px;
			overflow: hidden;
			margin-right: 15px;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.avatar-text {
			float: right;
			font-size: 14px;
			color: #333;
		}
	}

	@media (max-width: 1220px) {
		.login {
			right: 20px;
		}
	}

</style>



// WEBPACK FOOTER //
// src/views/layout/headerComponent.vue